<template>
  <div class="authx-preview">
    <div
      v-if="loading"
      v-loading="loading"
      class="authx-preview--loading"
    ></div>
    <template v-else>
      <nav class="authx-preview--nav">
        <h2>GetChat</h2>
        <ul>
          <li>Discover</li>
          <li>Pricing</li>
          <li>Community</li>
        </ul>
        <div>
          <el-button type="text" @click="initiateAuthxMethod('login')"
            >Login</el-button
          >
          <el-button type="primary" @click="initiateAuthxMethod('signup')"
            >Create Account</el-button
          >
        </div>
      </nav>
      <div class="authx-preview--hero">
        <div
          class="authx-preview--hero__text animate__animated animate__slideInUp"
        >
          <span>A simple app</span>
          <h1>Browse all assets smoothly.</h1>
          <p>Your solution to organising digital assets.</p>
          <div>
            <el-button
              type="primary"
              size="large"
              class="animate__animated animate__bounce"
              @click="initiateAuthxMethod('signup')"
              >Get started</el-button
            >
            <el-button type="text">Learn more</el-button>
          </div>
        </div>
        <div class="authx-preview--hero__content">
          <auth-x-preview-illustration
            class="animate__animated animate__slideInRight"
            :color="app && app.customization.meta_data.primary_color"
          />
        </div>
      </div>
    </template>
    <div class="authx-preview--note">
      <p>
        This is a sample website that uses your AuthX App for onboarding.
      </p>
    </div>
    <auth-x-preview-widget
      v-if="app"
      :app-id="app.id"
      :client-id="app.development.oauth.identifier"
    />
  </div>
</template>

<script>
import apiConstants from "@/apiConstants";
import AuthXPreviewWidget from "@/components/Products/AuthX/Applications/Preview/Widget.vue";
import AuthXPreviewIllustration from "@/components/Products/AuthX/Applications/Preview/Illustration.vue";

export default {
  name: "AuthxPreview",
  components: { AuthXPreviewWidget, AuthXPreviewIllustration },
  data() {
    return {
      loading: true,
      app: null,
      user: null,
      token: null
    };
  },
  computed: {
    appId() {
      return this.$route.params.id;
    },
    preview() {
      return this.$route.name.split(".")[2] === "index";
    },
    authx() {
      return window.authx ? window.authx : null;
    }
  },
  created() {
    const { code } = this.$route.query;
    if (!code) {
      this.$router.push({
        name: "authx.preview.index",
        params: { id: this.appId }
      });
    }

    this.getApp();

    const user = sessionStorage.getItem("$authxsession");
    this.user = user ? JSON.parse(user) : null;

    const token = sessionStorage.getItem("$authxaccesstoken");
    this.token = token ? token : null;
  },
  methods: {
    getApp() {
      this.loading = true;
      const apiUrl = `apps/${this.appId}`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (!resData) {
            this.loading = false;
            return;
          }
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.app = resData;
          }
          this.loading = false;
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    },
    initiateAuthxMethod(method) {
      if (!window.authx) {
        return;
      }
      switch (method) {
        case "login":
          window.authx.initiateSession();
          break;
        case "signup":
          window.authx.initiateSignupSession();
          break;
        case "token":
          window.authx.getAccessToken();
          break;
        case "logout":
          window.authx.logout();
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/components/authx-preview.scss";
</style>
